module.exports = __webpack_public_path__ + "static/media/ssl-logo.098c5c0f.webp";